import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSummaryBonus(params) {
	return client.get("binary/bonus/summary", {
		params: params,
	});
}

function getDetailBonusToday(params) {
	return client.get("binary/bonus/detail-komisi-hari-ini", {
		params: params,
	});
}

function getHistoryBonus(params) {
	return client.get("binary/bonus/history", {
		params: params,
	});
}

function getHistoryTransfer(params) {
	return client.get("binary/bonus/history-transfer", {
		params: params,
	});
}

function getDetailHistoryTransfer(params) {
	return client.get("binary/bonus/detail-transfer", {
		params: params,
	});
}

export default {
	getSummaryBonus,
	getDetailBonusToday,
	getHistoryBonus,
	getHistoryTransfer,
	getDetailHistoryTransfer,
};